// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDbD-CnQSq_tc-8LT8Bc_-WVgOETOTi4E8",
  authDomain: "ecommerce-a2af3.firebaseapp.com",
  projectId: "ecommerce-a2af3",
  storageBucket: "ecommerce-a2af3.appspot.com",
  messagingSenderId: "699596456781",
  appId: "1:699596456781:web:f6cb20ea9073ffc6112d04",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
